import { Loader } from '@grafikr/components';

export default Loader(({ node }, load) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          load();
        }
      });
    },
    { rootMargin: node.dataset.rootMargin || '200px', threshold: Number(node.dataset.threshold) || 0.1 },
  );

  observer.observe(node);
});
